export default {"src":"/_next/static/media/express.4a8f2c14.svg","height":20,"width":35,"blurWidth":0,"blurHeight":0};